import { render, staticRenderFns } from "./InfoMainBlock.vue?vue&type=template&id=010edf60&scoped=true&lang=pug&"
import script from "./InfoMainBlock.vue?vue&type=script&lang=js&"
export * from "./InfoMainBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoMainBlock.vue?vue&type=style&index=0&id=010edf60&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010edf60",
  null
  
)

export default component.exports